import React from "react";

const EmptyState = ({ icon, message, hint }) => (
  <div className="lr-empty">
    {icon && <i className={`pi ${icon} lr-empty-icon`} aria-hidden="true" />}
    <p className="lr-empty-message">{message}</p>
    {hint && <p className="lr-empty-hint">{hint}</p>}
  </div>
);

export default EmptyState;
